<template>
    <div class="mt-4">
        <form @submit.prevent="getResults()" class="form-inline">
            <label class="sr-only" for="search">Search</label>
            <input type="text" class="form-control searchbar-input mr-sm-2" :class="{'border border-danger' : error}" id="search" v-model="query" :placeholder="`Search for a patient name or ${patientIdentifierLabel.toLowerCase()}`">

            <button :disabled="loading" type="submit" class="btn btn-success btn-form sm-shadow btn-block-mobile mt-2 mt-sm-0" :class="{disabled : loading}">Search <span v-if="loading" class="btn-loading"></span></button>
            <button v-if="showClear" @click="clear()" class="btn btn-cancel btn-form sm-shadow btn-block-mobile mt-2 mt-sm-0 ml-2">Clear</button>
        </form>

        <small v-if="error" class="d-block text-danger mb-2">
            Please enter a patient name or {{ patientIdentifierLabel }} to search
        </small>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'PatientSearchbarComponent',

    data() {
        return {
            loading: false,
            showClear: false,
            query: null,
            error: false,
            pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE,
            offset: 0,
            sortColumn: 0,
            sortType: 0
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            facilityId: 'UserStore/GetUserFacilityId',
            patientIdentifierLabel: 'OrganisationStore/GetPatientIdentifierLabel'
        })
    },

    methods: {
        ...mapActions({
            setSelectAPatientSearchbarDataInSearchStore: 'SearchStore/SetSelectAPatientSearchbarData',
            setNotification: 'NotificationStore/SetNotification'
        }),

        async getResults() {
            this.loading = true
            this.error = false

            if(!this.query) {
                this.loading = false
                this.error = true
            }

            if(!this.error) {
                try {
                    let response = await axios.get(`${process.env.VUE_APP_AXIOS_PATIENT_BASE_URL}/api/v1/patients/${this.organisationId}/${this.query}/10/0/0/0`)

                    this.setSelectAPatientSearchbarDataInSearchStore({
                        patientText: this.query
                    })

                    this.$emit('updateResults', response.data)
                    this.showClear = true
                }
                catch(err) {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'An error occurred while fetching the results. Please try again'
                    })
                }
                finally {
                    this.loading = false
                }
            }
        },

        clear() {
            this.showClear = false
            this.query = null
            this.setSelectAPatientSearchbarDataInSearchStore({
                patientText: null
            })
            this.$emit('clear')
        }
    }
}
</script>